import UPTab from 'components/tab';
import { useTranslation } from 'react-i18next';
import { WAGE_COMPONENTS__COST_DECLARATION_HEADER, WAGE_COMPONENTS__SERVICE_CODES } from 'translations/constants';
import { SectionContainer } from 'modules/companies/styles';
import ServiceCodes from './service-codes/ServiceCodes';
import CostDeclaration from './cost-declarations/CostDeclaration';

const WageComponents = (): JSX.Element => {
  const [t] = useTranslation();

  const WageComponentsTabs = [t(WAGE_COMPONENTS__SERVICE_CODES), t(WAGE_COMPONENTS__COST_DECLARATION_HEADER)];

  return (
    <SectionContainer sx={{ paddingTop: '16px' }}>
      <UPTab sections={WageComponentsTabs}>
        <ServiceCodes />
        <CostDeclaration />
      </UPTab>
    </SectionContainer>
  );
};

export default WageComponents;
